import { Col, Form, Row } from 'antd'
import { get } from 'lodash'
import { defaultFormItemLayout } from '../../../../modules/FormItems'
import React from 'react'

function BankDetails (props) {
  const { contract } = props

  const bank = get(contract, 'bank', {})
  const isAccountCard = get(bank, 'accountType') === 'Card'
  const isMultiCurrency = !!get(bank, 'isMultiCurrency')
  const isIbank = !!get(bank, 'isIbank')
  console.log({ bank })

  return (
    <div>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Bank'}>
            {get(bank, 'branchName', '__N/A__')}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Account Type'}>
            {get(bank, 'accountType', '__N/A__')}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Status'}>
            {get(bank, 'status', '__N/A__')}
          </Form.Item>
        </Col>
      </Row>
      <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
        <h3 style={{ color: 'rgb(43,187,143' }}>ACCOUNT HOLDER DETAILS</h3>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Account Name'}>
            {get(bank, 'accountName', '__N/A__')}
          </Form.Item>
        </Col>
      </Row>
      {!isAccountCard && (
        <>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Account Number'}>
                {get(bank, 'accountNumber', '__N/A__')}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'IBAN'}>
                {get(bank, 'iban', '__N/A__')}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Is MultiCurrency'}>
                {get(bank, 'isMultiCurrency', 'NO')}
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
      {isAccountCard && (
        <>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Card Number">
                {get(bank, 'card.number', '__N/A__')}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Card Expiry">
                {get(bank, 'card.expiry', '__N/A__')}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Account Number'}>
                {get(bank, 'accountNumber', '__N/A__')}
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
      <Row>
        {!isMultiCurrency ? (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Currency'}>
              {get(bank, 'currency', '__N/A__')}
            </Form.Item>
          </Col>
        ) : (
          <>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Main Currency'}>
                {get(bank, 'currency', '__N/A__')}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={`Multi Currencies`}>
                {get(bank, 'multiCurrency', ['__N/A__']).join(', ')}
              </Form.Item>
            </Col>
          </>
        )}
      </Row>

      <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
        <h3 style={{ color: 'rgb(43,187,143' }}>BRANCH DETAILS</h3>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Branch Name'}>
            {get(bank, 'branchName', '__N/A__')}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Country'}>
            {get(bank, 'address.country', '__N/A__')}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item {...defaultFormItemLayout} label={'Branch Address'}>
            {get(bank, 'address.label', '__N/A__')}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'BIC/SWIFT'}>
            {get(bank, 'swiftCode', '__N/A__')}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="BSB / SORT Code">
            {get(bank, 'bsb', '__N/A__')}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Branch Code">
            {get(bank, 'address.branchCode', '__N/A__')}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Requires Intermediary'}>
            {get(bank, 'address.isIbank', '__N/A__')}
          </Form.Item>
        </Col>
      </Row>
      {isIbank && (
        <>
          <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
            <h3 style={{ color: 'rgb(43,187,143' }}>INTERMEDIARY DETAILS</h3>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Account Name'}>
                {get(bank, 'ibank.accountName', '__N/A__')}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Currency'}>
                {get(bank, 'ibank.currency', '__N/A__')}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Account Number'}>
                {get(bank, 'ibank.accountNumber', '__N/A__')}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'IBAN'}>
                {get(bank, 'ibank.iban', '__N/A__')}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Bank Name">
                {get(bank, 'ibank.name', '__N/A__')}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Branch">
                {get(bank, 'ibank.branch', '__N/A__')}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="SWIFT Code">
                {get(bank, 'ibank.swift', '__N/A__')}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item {...defaultFormItemLayout} label="Address">
                {get(bank, 'ibank.address.label', '__N/A__')}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Country'}>
                {get(bank, 'ibank.address.country', '__N/A__')}
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
    </div>
  )
}

export default BankDetails
